import {
  DataDetectorTypes,
  InputModeOptions,
  KeyboardTypeOptions,
  Pressable,
} from "react-native";
import { EyeIcon, EyeOffIcon, Icon } from "ui/gluestack/icon";
import { Input, InputField } from "ui/gluestack/input";
import { useEffect, useMemo, useState } from "react";
import { TextInputProps } from "./interfaces";

export function TextInput({
  id = "",
  placeholder = "",
  value,
  className = "",
  type = "text",
  variant,
  isDisabled,
  autoFocus,
  icon,
  onChange,
  onSubmitEditing,
  onBlur,
}: TextInputProps) {
  const [localType, setLocalType] = useState(type);
  const secureTextEntry = useMemo(() => localType === "password", [localType]);
  const keyboardType = useMemo<KeyboardTypeOptions>(
    () =>
      ({
        email: "email-address",
        numeric: "number-pad",
        decimal: "decimal-pad",
      })[type] || "default",
    [type],
  );

  const inputMode = useMemo<InputModeOptions>(
    () =>
      ({
        search: "search",
        numeric: "number",
        decimal: "decimal",
        email: "email",
        address: "text",
        phone: "text",
        link: "text",
      })[type] || "text",
    [type],
  );

  const detectorType = useMemo<DataDetectorTypes>(
    () =>
      ({
        address: "address",
        phone: "phoneNumber",
        link: "link",
      })[type] || "all",
    [type],
  );

  useEffect(() => {
    setLocalType(type);
  }, [type]);

  const togglePasswordMode = () => {
    setLocalType((prevType) => (prevType === "password" ? "text" : "password"));
  };
  return (
    <Input variant={variant}>
      <InputField
        id={id}
        value={value}
        onChangeText={onChange}
        placeholder={placeholder}
        secureTextEntry={secureTextEntry}
        keyboardType={keyboardType}
        inputMode={inputMode}
        onSubmitEditing={onSubmitEditing}
        dataDetectorTypes={detectorType}
        readOnly={isDisabled}
        autoFocus={autoFocus}
        className={`px-3.5 py-2.5 flex-1 ${className}`}
        onBlur={() => onBlur?.(value)}
      />
      {icon ? (
        icon
      ) : type === "password" ? (
        <Pressable
          onPress={togglePasswordMode}
          className="flex items-center px-2 h-full justify-center"
        >
          <Icon
            as={localType !== "password" ? EyeOffIcon : EyeIcon}
            className="w-5 h-5 text-gray-500"
          />
        </Pressable>
      ) : null}
    </Input>
  );
}
